import { getPatient, getTsFromM3U8Link } from '../lib/api'
import storage from '../lib/storage'
import { fetchWithTimeout } from '../fetcher/fetcher-timeout'
import { API_URL, MUSIC_URL } from '../fetcher/constants'
import { examFactory } from './functions'

export const loadExamSource = async () => {
    try {
        const { payment, data } = await getPatient()

        if (payment) {
            return { paymentRedirect: payment }
        }

        const patientData = examFactory(data)
        const { introURL, m3u8, mp4Url, date, examId, cycle, examStatus } = patientData

        let vmusicError = false
        let useM3U8 = false
        let kalturaM3u8 = ''

        try {
            const response = await fetch(`${API_URL}/patient/media/${examId}/${cycle}/vmusic-token`, {
                headers: {
                    Authorization: `Bearer ${storage.getToken()}`,
                },
            })
            const vmusicToken = await response.text()
            kalturaM3u8 = `${MUSIC_URL}/v1/vlab/m3u8/${examId}/${vmusicToken}/vod.m3u8`

            const optionsResponse = await fetch(kalturaM3u8)
            if (!optionsResponse.ok) {
                throw new Error('M3U8 não disponível')
            }

            const responseText = await optionsResponse.text()
            const urlPattern = /https?:\/\/[^\s"]+/g
            const match = responseText.match(urlPattern)
            if (match && match[0]) {
                await fetchWithTimeout(match[0], 3000)
            }

            useM3U8 = true
        } catch (e) {
            console.error('Falha ao obter vmusic-token ou URL interna inválida, usando fallback:', e)
            vmusicError = true
            const responseM3U8 = await getTsFromM3U8Link(m3u8)
            if (responseM3U8) {
                useM3U8 = true
            }
        }

        if (useM3U8) {
            if (!vmusicError) {
                return {
                    patient: {
                        intro: introURL || '',
                        src: kalturaM3u8,
                        type: 'application/x-mpegURL',
                        date,
                        examStatus,
                    },
                }
            }
            if (mp4Url) {
                return {
                    patient: {
                        intro: introURL || '',
                        src: mp4Url,
                        type: 'video/mp4',
                        date,
                        examStatus,
                    },
                }
            }
            if (m3u8) {
                return {
                    patient: {
                        intro: introURL || '',
                        src: m3u8,
                        type: 'application/x-mpegURL',
                        date,
                        examStatus,
                    },
                }
            }
            return {
                patient: {
                    intro: '',
                    src: '',
                    type: 'video/mp4',
                    date,
                    examStatus,
                },
            }
        }

        return {
            patient: {
                intro: introURL || '',
                src: mp4Url,
                type: 'video/mp4',
                date,
                examStatus,
            },
        }
    } catch (error) {
        throw error
    }
}
